import { CALL_API } from 'redux-api-middleware';
import debounce from 'lodash/debounce';

import { createRequestTypes } from './utils';
import { buildSearchUrl } from '../service/oms';

export const SEARCH = createRequestTypes('@@search/SEARCH');
export const SET_QUERY = '@@search/SET_QUERY';

export function setQuery(query) {
    return { type: SET_QUERY, query };
}

const debouncedSearch = debounce((query, dispatch) => {
    const types = [SEARCH.REQUEST, SEARCH.SUCCESS, SEARCH.FAILURE].map(
        type => ({ type, meta: { query } })
    );
    return dispatch({
        [CALL_API]: {
            endpoint: buildSearchUrl(query),
            method: 'GET',
            types,
        },
    });
}, 200);

export function search(query) {
    return dispatch => {
        dispatch(setQuery(query));

        if (query.length > 2) {
            debouncedSearch(query, dispatch);
        }
    };
}



/** WEBPACK FOOTER **
 ** /src/shared/actions/search.js
 **/